import React, { useEffect, useState } from "react";
import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";
import "./GlobalToast.css";

const GlobalToast = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handleToast = (event) => {
      const detail = event.detail || {};
      const id = `${Date.now()}-${Math.random()}`;
      const toast = {
        id,
        message: String(detail.message ?? ""),
        type: detail.type || "info",
      };

      setToasts((prev) => [...prev, toast]);

      window.setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.id !== id));
      }, detail.duration || 3500);
    };

    window.addEventListener("app-toast", handleToast);
    return () => window.removeEventListener("app-toast", handleToast);
  }, []);

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  const iconFor = (type) => {
    if (type === "success") return <CheckCircle2 size={20} />;
    if (type === "error" || type === "danger") return <AlertCircle size={20} />;
    return <Info size={20} />;
  };

  return (
    <div className="global-toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div key={toast.id} className={`global-toast global-toast-${toast.type}`}>
          <div className="global-toast-icon">{iconFor(toast.type)}</div>
          <div className="global-toast-message">{toast.message}</div>
          <button
            type="button"
            className="global-toast-close"
            onClick={() => removeToast(toast.id)}
            aria-label="Close notification"
          >
            <X size={17} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default GlobalToast;
